const BET_RESULT_CLASS = {
  bet_exact: 'ranking__item__column__goals--exact',
  bet_no_points: '',
  bet_result: 'ranking__item__column__goals--result',
  bet_goal_diff: 'ranking__item__column__goals--tendency'
}

export default {
  methods: {
    isBetHiddenUntilResult (match, user) {
      return user != this.$store.state.user.id &&
        !this.isNumeric(match.goalshome) && !this.isNumeric(match.goalsguest) &&
        !this.isNumeric(match.livegoalshome) && !this.isNumeric(match.livegoalsguest)
    },
    getBetByMatchUser (match, user) {
      // Higher-order vuex getters are not reactive. Reading store arrays during
      // render registers deps so the view updates when tips arrive (needed on
      // iOS WKWebView; Android often re-renders later via another store update).
      void this.$store.state.allbets
      void this.$store.state.bets
      return this.$store.getters.getAllBetByMatchUser(this.$store.state.betgameId, match.id, user)
    },
    getRankingPoints (bet, match) {
      if (bet === null || match === null) return -1
      if (match.status && match.status === 'Wertung') return -1
      if (!this.isNumeric(match.goalshome) && !this.isNumeric(match.goalsguest) &&
          !this.isNumeric(match.livegoalshome) && !this.isNumeric(match.livegoalsguest)) {
        return -1
      }
      return this.getPointsBy(this.$store.state.betgame, bet, match)
    },
    getBetResult (match, user) {
      const bp = this.betPoints(match, user)
      switch (bp) {
        case this.pointsBetResult:
          return 'bet_exact'
        case this.pointsBetGoaldiff:
          return 'bet_goal_diff'
        case this.pointsBetTendency:
          return 'bet_result'
        default:
          return 'bet_no_points'
      }
    },
    getClass (match, user) {
      const bp = this.betPoints(match, user)
      return {
        bet_exact: bp === this.pointsBetResult,
        bet_goal_diff: bp === this.pointsBetGoaldiff,
        bet_result: bp === this.pointsBetTendency,
        bet_no_points: bp === 0
      }
    },
    betGoalsCellClass (match, user) {
      const result = this.getBetResult(match, user)
      const classes = ['ranking__item__column__goals']
      const modifier = BET_RESULT_CLASS[result]
      if (modifier) classes.push(modifier)
      if (result === 'bet_no_points' && this.otherBetAvailable && this.otherBetAvailable(match, user)) {
        classes.push('ranking__item__column__goals--entered')
      }
      return classes
    },
    betScore (match, user) {
      if (this.isBetHiddenUntilResult(match, user)) return '-:-'
      const tip = this.getBetByMatchUser(match, user)
      if (tip != null && this.isNumeric(tip.goalshome) && this.isNumeric(tip.goalsguest)) {
        return tip.goalshome + ' : ' + tip.goalsguest
      }
      return '-:-'
    },
    // Keep `bet` as alias for any older call sites
    bet (match, user) {
      return this.betScore(match, user)
    },
    betToto (match, user) {
      if (this.isBetHiddenUntilResult(match, user)) return '-'
      const tip = this.getBetByMatchUser(match, user)
      if (tip != null && this.isNumeric(tip.goalshome) && this.isNumeric(tip.goalsguest)) {
        return tip.goalshome
      }
      return '-'
    },
    livepoints (user) {
      let result = 0
      for (let i = 0; i < this.matches.length; i++) {
        const match = this.matches[i]
        const tip = this.getBetByMatchUser(match, user)
        const p = this.getRankingPoints(tip, match)
        if (p > -1) result += p
      }
      return result
    }
  }
}
